/**
 * Created by User on 10/1/2560.
 */
import {
   Component, ChangeDetectorRef, ComponentFactoryResolver, ComponentRef,
   ElementRef, OnInit, Renderer2, ViewChild, ViewContainerRef, HostListener
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MomentPipe } from 'app/shared/moment.pipe';
import { TranslateService } from '@ngx-translate/core';
import { Mimetype } from 'app/shared/mimetype';
import { Toast } from 'app/shared/toast/toast';
import { DocTypeComponent } from '../../../shared/doctype.component';
import { AnnotationControllerService } from 'app/dms/annotation-controller/annotation-controller.service';
import { zDoxItem } from '../../../shared/types';
import { DocumentData } from '../../annotation-controller/document-data.type';
import { AnnotationControllerComponent } from 'app/dms/annotation-controller/annotation-controller.component';

declare let $: any;
declare let moment: any;
declare const isPdfTron: boolean; // Value declared in index.html

@Component({
   selector: 'app-share-viewer',
   templateUrl: './share-viewer.component.html',
   styleUrls: ['../../viewer/viewer.component.css'],
})
export class ShareViewerComponent implements OnInit {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   isPdfTron = isPdfTron;

   doc: zDoxItem = {};
   documentData: DocumentData;

   canNotPreview: boolean;
   text: string;
   svg: SafeHtml;
   mail: any;
   imageUrl: string;
   pdfUrl: SafeResourceUrl;
   videoUrl: string;
   audioUrl: string;
   types: any[];
   post = 'ส่ง';
   lastModified: any;
   error: string;

   errorMessage: string;
   doc_id: any;
   // size: any = '';
   size = 5242880;
   path: any;
   content: any;
   lenght_property: any;
   success: any;
   comment: any;
   settype = false;
   loaded = false;

   show: boolean;
   action_status = true;
   saveText = 'Save';
   form: any;
   canPrint: boolean;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   @ViewChild('info') info: ElementRef;
   @ViewChild('selectType') selectType: any;
   @ViewChild('form2', { read: ViewContainerRef }) form2: ViewContainerRef;
   @ViewChild('pdftron') pdfTronComp: AnnotationControllerComponent
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px
   canDownload = true;
   cancel = false;
   selectedValue: string;

   shared: boolean;

   constructor(private route: ActivatedRoute,
               private router: Router,
               public service: IdexService,
               private sanitizer: DomSanitizer,
               public dialog: MatDialog,
               private renderer: Renderer2,
               private resolver: ComponentFactoryResolver,
               private translate: TranslateService,
               private changeDetector: ChangeDetectorRef,
               private toast: Toast,
               private annoService: AnnotationControllerService) {
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   ngOnInit() {
      if (sessionStorage.getItem('shared')) {
         this.shared = true;
      }

      this.service.logoUrl = sessionStorage.getItem('logoUrl');
      sessionStorage.removeItem('logoUrl');

      if (!this.service.shareDocId) {
         this.service.shareId = sessionStorage.getItem('shareId');
         this.service.shareDocId = sessionStorage.getItem('shareDocId');
         this.service.isDownload = sessionStorage.getItem('isDownload') === 'true';
         this.service.permissionLevel = parseInt(sessionStorage.getItem('permissionLevel'), 10);

         sessionStorage.removeItem('shareId');
         sessionStorage.removeItem('shareDocId');
         sessionStorage.removeItem('isDownload');
         sessionStorage.removeItem('permissionLevel');
      }

      this.route.params.forEach((params: Params) => {
         this.doc_id = params['id'];
         this.canDownload = sessionStorage.getItem('dl') !== null && sessionStorage.getItem('dl') === 'false' ? false : true;
         this.getDocument();
         this.getComment();
      });

      this.annoService.getNotesPanelVisibilityStatus().subscribe((isNotesPanelOpen) => {
         // If NotesPanel is open while side panel is already open, hide side panel
         if (isNotesPanelOpen && this.info?.nativeElement.className.indexOf('slide-right') === -1) {
            this.closeSidePanel();
         }
      });
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      sessionStorage.setItem('shareId', this.service.shareId);
      sessionStorage.setItem('shareDocId', this.service.shareDocId);
      sessionStorage.setItem('isDownload', this.service.isDownload.toString());
      sessionStorage.setItem('permissionLevel', this.service.permissionLevel.toString());
      sessionStorage.setItem('logoUrl', this.service.logoUrl);
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   getDocument(): void {
      const userSharer = sessionStorage.getItem('user-sharer');
      this.service.getShareDocument(this.doc_id, userSharer)
          .subscribe((data: any) => {
                this.doc = data;
                this.show = Mimetype.canEdit(this.doc);
                this.canPrint = Mimetype.canPrint(this.doc);
                this.initDocument();
                if (!data.typeName) {
                   this.service.getShareTypes().subscribe(dataType => { this.types = dataType; });
                }
             },
             (error: any) => {
                this.loaded = true;
                this.errorMessage = error;
             });
   }

   initDocument(): void {
      const sharer = sessionStorage.getItem('user-sharer');
      const mimeType = this.doc.mimeType;
      if (mimeType === 'application/pdf'
         || ((mimeType === 'application/vnd.oasis.opendocument.text'
         || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
         || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         || mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
         || mimeType === 'application/msword'
         || mimeType === 'application/vnd.ms-excel'
         || mimeType === 'image/tiff'
         || mimeType === 'application/vnd.ms-powerpoint') && this.doc.size <= this.size)) {
         const file = encodeURIComponent(this.service.url + '/share-public/content?id=' + this.doc_id + '&s=' + sharer + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         // LOAD PDF DOCUMENT TO RENDER IN PDFTRON
         const docUrl = this.service.url + '/share-public/content?id=' + this.doc.id + '&isPdfTron=' + isPdfTron + '&' + Date.now();
         this.extracted(docUrl);

         // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
         this.documentData.fileFormat = "pdf";
      } else if (mimeType === 'image/jpeg' || mimeType === 'image/png'
                || mimeType === 'image/gif' || mimeType === 'image/bmp') {
         this.imageUrl = this.service.url + '/share-public/content?id=' + this.doc_id + '&' + Date.now();
         this.extracted(this.imageUrl);
      } else if (mimeType === 'image/svg+xml') {
         const url = '/share-public/content?id=' + this.doc_id;
         this.extracted(url);
         this.service.get(url, {responseType: 'text'}).subscribe(data => {
            this.svg = this.sanitizer.bypassSecurityTrustHtml(data);
            this.loaded = true;
         });
      } else if (mimeType.indexOf('video/') === 0 && mimeType !== 'video/mpeg' && mimeType !== 'video/avi'
         && mimeType !== 'video/msvideo' && mimeType !== 'video/x-msvideo') {
         this.videoUrl = this.service.url + '/share-public/content?id=' + this.doc_id;
      } else if (mimeType.indexOf('audio/') === 0) {
         this.audioUrl = this.service.url + '/share-public/content?id=' + this.doc_id;
      } else if (mimeType.indexOf('text/') === 0 || mimeType === 'application/xml') {
         const url = '/share-public/content?id=' + this.doc_id;
         this.service.get(url, {responseType: 'text'}).subscribe(data => {
            this.text = data;
            this.loaded = true;
         });
      } else if (mimeType === 'message/rfc822') {
         const url = '/share-public/content?id=' + this.doc_id;
         this.service.get(url).subscribe((data: any) => {
            data.from = this.formatAddress(data.from);
            data.to = this.formatAddress(data.to);
            if (data.cc) { data.cc = this.formatAddress(data.cc); }
            if (data.html) {
               data.html = this.sanitizer.bypassSecurityTrustResourceUrl('data:text/html,' + data.html);
            }
            this.mail = data;
            this.loaded = true;
         }, error => {
            this.error = error;
            this.loaded = true;
         });
      } else {
         this.canNotPreview = true;
         this.loaded = true;
      }
      const fmt = new MomentPipe();
      this.lastModified = { when: fmt.transform(this.doc.modified) };
   }

   /**
    * Extract properties from 'doc' to 'documentData'
    *
    * Straight copy from 'viewer.component.ts'
    *
    * @param url
    * URL of the document to show via PDFTron
    */
   private extracted(url: string): void {
      this.documentData = {
         url: url + '&includeWatermark=false',
         fileName: encodeURIComponent(this.doc.name),
         type: this.doc.type,
         mimeType: this.doc.mimeType,
         docId: this.doc.id,
         path: this.doc.path,
         statusStartFlow: this.doc.startFlow,
         statusDocument: this.doc.statusDocument,
         isPermissions: this.doc.permissions,
         allowDownloadAndPrint: this.canDownload,
         watermark: this.doc.watermark,
         actionType: "dms",
      };
      this.loaded = true; // Don't know what this is
      this.renderer.addClass(this.info.nativeElement, 'slide-right'); // Don't know what this is
   }

   private formatAddress(array: any[]): string {
      let s = '';
      array.forEach(addr => {
         if (s.length > 0) { s += ', '; }
         if (addr.name) {
            s += '<b>' + addr.name + '</b> ';
         }
         s += '&lt;' + addr.address + '&gt;';
      });
      return s;
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.cancel = false;
         that.changeDetector.detectChanges();
      });

      setTimeout(() => {
         if (!this.loaded) {
            this.loaded = true;
            this.cancel = true;
         }
      }, 20000);
   }

   openAttach(a: any) {
      const url = this.service.url + '/share-public/attachment?id=' + this.doc.id + '&aid=' + a.id;
      window.open(url, a.id || this.doc.id);
   }

   download() {
      location.href = this.service.url + '/share-public/download?id=' + this.doc.id;
   }

   back() {
      if (this.pdfTronComp) {
         const result = this.pdfTronComp.handleUnsavedChangesOnExit();
         if (this.pdfTronComp.unsaveTemplate$) {
         const sub = this.pdfTronComp.unsaveTemplate$.subscribe((val: string) => {
            if (val === 'unsave') {
               this.navigateBack();
               sub.unsubscribe();
            }
         });
         } else {
         this.navigateBack();
         }
      }
   }

   linkify(s: string): string {
      if (!s) {
         return s;
      }
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      // www. sans http:// or https://
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      // Email addresses *** here I've changed the expression ***
      const emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
      return s.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
              .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
              .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
   }

   snackDialog(word: any): void {
      this.success = word;
      const x = document.getElementById('snackbar');
      x.className = 'show';

      setTimeout(() => {
         x.className = x.className.replace('show', '');
      }, 2000);

   }
   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   getComment(): void {
      this.service.getShareComment(this.doc_id).subscribe(
          data => {
             this.comment = data.items;
          });
   }

   private getProperties(form: any[]) {
      const error = function(e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (let i = 0; i < form.length; i++) {
         const f = form[i];
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }
   private updateContainerHeight() {
      setTimeout(() => {
         const height = $('.info-body:visible').outerHeight(true) + $('.info-title').outerHeight(true);
         $('.list-container').css('min-height', height + 'px');
         this.adjustInfoPosition();
      }, 100);
   }
   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) { return; }

      const title = $('.info-title');
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + 'px';
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) { y = x - height; }
            info.css({ top: y + 'px' });
         } else {
            info.css({ top: top });
         }
      } else {
         info.css({ top: top });
      }
   }
   loadForm(name: string) {
      this.form = undefined;
      this.service.getShareType(name).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         this.updateContainerHeight();
      });
   }

   toggle(): void {
      if (!this.info) return;

      // If side panel is currently open
      if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
         // Hide side panel
         this.closeSidePanel();
      } else {
         // Show side panel
         this.openSidePanel();
      }
   }

   closeSidePanel(): void {
      this.renderer.addClass(this.info.nativeElement, 'slide-right');
   }

   openSidePanel(): void {
      //| When DMS side panel is open,
      //| if PDFTron's NotesPanel is also open, close it.
      this.annoService.instance?.UI.closeElements(['notesPanel']);
      this.annoService.instance?.Core.documentViewer.getAnnotationManager().deselectAllAnnotations();

      this.renderer.removeClass(this.info.nativeElement, 'slide-right');
   }

   printFrame() {
      const iframe = window.frames['printf'];
      iframe.focus();
      iframe.print();
   }

   navigateBack() {
      const url = localStorage.getItem('url');
      localStorage.removeItem('pdfjs.history');
      if (url) {
         const path = url;
         const search = '/search';
         if (path.startsWith(search)) {
            const param = path.substring(path.indexOf('=') + 1 );
            this.router.navigate([search], { queryParams: { q: param } });
            localStorage.removeItem('url');
            return;
         }
         this.router.navigate([url]);
         localStorage.removeItem('url');
         sessionStorage.setItem('verify', 'true');
      } else {
         localStorage.setItem('first_files_open', 'true');
         window.history.back();
      }
   }
}
